/**
 * popupBox plugin — port 1:1 din legacy common.js lines 1666-1698.
 * Toggle pe `.popup-box` sibling, cu `.popup-modal` backdrop.
 */

import { $ } from '../core/selector.js';

Node.prototype.popupBox = function (this: Node): void {
    const popup = this.next('.popup-box') as HTMLElement | null;
    if (!popup) return;

    this.on('click', function () {
        popup.style.display = 'block';
        popup.classList.add('fade-in');
        const backdrop = $('<div class="popup-modal fade-in" />') as HTMLElement | null;
        if (backdrop) popup.before(backdrop);
    });

    popup.on('click', 'a.close', function () {
        popup.style.display = 'none';
        const modal = popup.prev('.popup-modal') as HTMLElement | null;
        if (!modal) return;
        modal.classList.add('fade-out');
        modal.addEventListener('animationend', function (this: HTMLElement, e: Event) {
            e.stopPropagation();
            this.remove();
        });
    });
};

NodeList.prototype.popupBox = function (this: NodeList) {
    this.forEach((node) => { (node as Node).popupBox(); });
    return this;
} as NodeList['popupBox'];
